<script>
  import { parc } from "../store/ImmoStore";
  import CardAppt from "../components/ihm/CardAppt.svelte";
  import Chartd3 from "../components/graph/D3BulleGraphe.svelte";// Svend3r bibliotheque D3 pour svelte

  let showDetail;
let dataGrDetail = [];
  /**
   *
   * @param data
   */
  const listAppt = (data) => {
    let result = [];
    if ($parc != undefined) {
      result = data.filter((el) => {
        return el.IM_VENDU == 0;
      });
      //console.log(result);
    }
    return result;
  };

  /**
 * creation du tableau data pour le graph Detail
 */
  const dataGraphDetail = (listAppt) => {
     for(const [key,value] of Object.entries(listAppt)){
        if (value.IM_INDIVISION == 1){
            dataGrDetail.push({'id': value.IM_NOM, 'value': Math.round(value.IM_PX_VTE/2)})
        }else{
            dataGrDetail.push({'id': value.IM_NOM, 'value': value.IM_PX_VTE})
        }

     }
     //console.log("dataGrDetail "+JSON.stringify(dataGrDetail))
     showDetail = true;
}


  /**
   *
   * @param letype
   *
   */
  const chercher = ( data) => {
    const listeData = listAppt( data);
    dataGraphDetail(listeData)
    //showDetail = true;
  };

</script>

<div class="container">

  <h5>Liste Appt</h5>
  {#await $parc then}
    <div class="col-xl-12">
      <table width="100%" class="table table-primary table-striped">
        <thead>
          <tr>
            <td>Nom</td>
            <td>PA</td>
            <td>Date Fin.P</td>
            <td>Pret</td>
            <td>Loyer</td>
            <td>Agence</td>
          </tr>
        </thead>
        <tbody>
          {#each listAppt($parc) as item}
            <tr>
              <td>{item.IM_NOM}</td>
              <td>{new Intl.NumberFormat("fr-FR").format(item.IM_PA)}</td>
              <td>{item.IM_FIN_PRET}</td>
              <td>{new Intl.NumberFormat("fr-FR").format(item.IM_PRET_MT)}</td>
              <td>{item.IM_MT_LOYER}</td>
              <td>{item.IM_AGENCE}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>

      <button
        on:click={chercher($parc)}
        type="button"
        class="btn btn-primary">Détail</button
      >
      {#if showDetail}
        <Chartd3 data = {dataGrDetail} />
      {/if}

    {#each listAppt($parc) as appt}
      <div class="card col-12">
        <CardAppt
          cardObject={appt}
        />
      </div>
    {/each}
  {/await}
</div>

<style>
  table {
    font-size: 0.75em;
  }
</style>
